import React from 'react';
import { Segmented } from '@duxton-web/ui';

import { isMultiEnvEnabled } from '@/common/environment';
import { SystemEnvironment } from '@/constants/systemEnviroment';
import { useAppContext, useAppDispatchContext } from '@/contexts/app-context';
import { setEnvironment } from '@/store/actions/app/action-creators';

const EnvironmentToggle = () => {
  const appContext = useAppContext();
  const { environment } = appContext;

  const appDispatch = useAppDispatchContext();

  if (!isMultiEnvEnabled()) return false;

  return (
    <Segmented
      value={environment}
      size="small"
      options={[
        {
          label: 'Staging',
          value: SystemEnvironment.STAGING,
        },
        {
          label: 'Production',
          value: SystemEnvironment.PRODUCTION,
        },
      ]}
      onChange={(value) => {
        appDispatch(setEnvironment(value as SystemEnvironment));

        const url = new URL(window.location.href);
        url.searchParams.set('env', value);
        window.history.replaceState({}, '', url.toString());

        window.location.reload();
      }}
      style={{
        width: 'fit-content',
      }}
    />
  );
};

export default EnvironmentToggle;
